import { useRef, useEffect } from "react"
import { CylinderMaterialShader } from "./CylinderShader"
import { useFrame } from "@react-three/fiber"

import * as THREE from 'three'

export function CylinderMaterial() {
    const mat = useRef()
    const scrollBoost = useRef(false)
    const tunnelOffset = useRef(0)

    useEffect(() => {
        const onWheel = () => {
            scrollBoost.current = true
        }

        window.addEventListener("wheel", onWheel, { passive: true })
        return () => window.removeEventListener("wheel", onWheel)
    }, [])

    useFrame((state, delta) => {
        if (!mat.current) return

        //Couleurs ici car direct en glsl couleurs trop pâle, je ne sais pas pourquoi encore
        mat.current.uBaseColor = new THREE.Color("#0d253c")
        mat.current.uCyanColor = new THREE.Color("#4e6ecf")
        mat.current.uMagentaColor = new THREE.Color("#ff83c4")

        const edgeBlue = new THREE.Color("#33CCFF").multiplyScalar(2.0)
        const edgeViolet = new THREE.Color("#5b58fd").multiplyScalar(2.0)

        mat.current.uEdgeBlueColor = edgeBlue
        mat.current.uEdgeVioletColor = edgeViolet

        // fade du boost
        scrollBoost.current = THREE.MathUtils.lerp(
            scrollBoost.current,
            0,
            delta * 1.5
        )

        const baseSpeed = mat.current.uSpeed
        const boostAmount = mat.current.uBoostAmount
        const currentSpeed = baseSpeed * (1 + scrollBoost.current * boostAmount * 1.5)

        tunnelOffset.current += currentSpeed * delta

        // 👇 on n’utilise PLUS elapsedTime, juste l’offset cumulé
        mat.current.uTime = tunnelOffset.current
        mat.current.uScrollBoost = scrollBoost.current
    })
    return (
        <cylinderMaterialShader ref={mat} side={THREE.DoubleSide} />
    )
}